/* ============================================
   DISABLE DAWN STICKY HEADER
   ============================================ */

(function () {
  "use strict";

  if (window.customElements && !customElements.get("sticky-header")) {
    customElements.define(
      "sticky-header",
      class extends HTMLElement {
        connectedCallback() {
          const wrapper = document.createElement("div");
          wrapper.className = "header-static-wrapper";
          wrapper.innerHTML = this.innerHTML;
          this.parentNode.replaceChild(wrapper, this);
        }
      }
    );
  }

  const forceStaticHeader = () => {
    const elements = [
      document.querySelector(".shopify-section-header-sticky"),
      document.querySelector(".header-wrapper"),
      document.querySelector("sticky-header"),
      document.querySelector(".announcement-bar"),
    ];

    elements.forEach((el) => {
      if (el) {
        el.style.setProperty("position", "static", "important");
        el.style.setProperty("transform", "none", "important");
        el.style.setProperty("top", "auto", "important");
        el.style.setProperty("transition", "none", "important");
      }
    });

    const announcementBar = document.querySelector(".announcement-bar");
    if (announcementBar) {
      announcementBar.style.setProperty("display", "block", "important");
      announcementBar.style.setProperty("opacity", "1", "important");
      announcementBar.style.setProperty("visibility", "visible", "important");
    }
  };

  forceStaticHeader();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", forceStaticHeader);
  }

  window.addEventListener("load", forceStaticHeader);

  const observer = new MutationObserver(() => {
    forceStaticHeader();
  });

  const startObserving = () => {
    const header =
      document.querySelector(".shopify-section-header-sticky") ||
      document.querySelector(".header-wrapper");
    if (header) {
      observer.observe(header, {
        attributes: true,
        attributeFilter: ["style", "class"],
        childList: false,
        subtree: false,
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving);
  } else {
    startObserving();
  }

  let scrollTimeout;
  window.addEventListener(
    "scroll",
    () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(forceStaticHeader, 0);
    },
    { passive: true }
  );

  let resizeTimeout;
  window.addEventListener(
    "resize",
    () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(forceStaticHeader, 0);
    },
    { passive: true }
  );

  const criticalStyle = document.createElement("style");
  criticalStyle.id = "brutalist-header-fix";
  criticalStyle.textContent = `
    .shopify-section-header-sticky,
    .header-wrapper,
    sticky-header {
      position: static !important;
      top: auto !important;
      transform: none !important;
      transition: none !important;
    }
    .announcement-bar {
      position: static !important;
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
  `;
  document.head.insertBefore(criticalStyle, document.head.firstChild);
})();

/* ============================================
   QUANTITY INPUT COMPONENT
   ============================================ */

if (!customElements.get("quantity-input")) {
  customElements.define(
    "quantity-input",
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) =>
          button.addEventListener("click", this.onButtonClick.bind(this))
        );
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (
          event.target.name === "plus" ||
          event.target.closest("button")?.getAttribute("name") === "plus"
        ) {
          this.input.stepUp();
        } else {
          this.input.stepDown();
        }

        if (previousValue !== this.input.value) {
          this.input.dispatchEvent(this.changeEvent);
        }
      }
    }
  );
}

/* ============================================
   OVERRIDE PRODUCT-FORM TO PREVENT REDIRECT
   ============================================ */

if (customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class BrutalistProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        if (this.form) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        handleAddToCart(evt, this.form);
      }
    }
  );
} else {
  customElements.define(
    "product-form",
    class BrutalistProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        if (this.form) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        handleAddToCart(evt, this.form);
      }
    }
  );
}

/* ============================================
   BRUTALIST ADD TO CART - AJAX (NO REDIRECT)
   ============================================ */

function handleAddToCart(e, form) {
  e.preventDefault();

  const submitBtn = form.querySelector(
    '.brutalist-button--add-to-cart, [name="add"]'
  );

  if (!submitBtn || submitBtn.classList.contains("loading")) return;

  submitBtn.classList.add("loading");
  submitBtn.setAttribute("disabled", "disabled");

  const formData = new FormData(form);

  const cartNotification = document.querySelector("cart-notification");
  const cartDrawer = document.querySelector("cart-drawer");

  if (
    cartNotification &&
    typeof cartNotification.getSectionsToRender === "function"
  ) {
    formData.append(
      "sections",
      cartNotification
        .getSectionsToRender()
        .map((s) => s.id)
        .join(",")
    );
    formData.append("sections_url", window.location.pathname);
  } else if (
    cartDrawer &&
    typeof cartDrawer.getSectionsToRender === "function"
  ) {
    formData.append(
      "sections",
      cartDrawer
        .getSectionsToRender()
        .map((s) => s.id)
        .join(",")
    );
    formData.append("sections_url", window.location.pathname);
  }

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422 || data.status === "bad_request") {
        console.error(
          data.description || data.message || "Błąd dodawania do koszyka"
        );
        return;
      }

      if (cartNotification && data.sections) {
        cartNotification.renderContents(data);
        if (typeof cartNotification.open === "function") {
          cartNotification.open();
        }
      } else if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data);
        if (typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      }

      updateCartCount();

      document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      submitBtn.classList.remove("loading");
      submitBtn.removeAttribute("disabled");
    });
}

function updateCartCount() {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((res) => res.json())
    .then((cart) => {
      document
        .querySelectorAll(
          '.cart-count-bubble span[aria-hidden="true"], [data-cart-count]'
        )
        .forEach((el) => {
          el.textContent = cart.item_count;
        });

      const bubble = document.querySelector(".cart-count-bubble");
      if (bubble) {
        if (cart.item_count > 0) {
          bubble.classList.remove("hidden");
        } else {
          bubble.classList.add("hidden");
        }
      }
    })
    .catch((err) => console.error("Error updating cart count:", err));
}

/* ============================================
   FALLBACK: INTERCEPT ALL PRODUCT FORMS
   ============================================ */

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(
      '.brutalist-variant-form, form[action*="/cart/add"], [data-type="add-to-cart-form"]'
    )
    .forEach((form) => {
      if (!form.dataset.ajaxBound) {
        form.dataset.ajaxBound = "true";
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleAddToCart(e, form);
        });
      }
    });
});

/* ============================================
   PORTAL CART NOTIFICATION TO BODY TOP
   ============================================ */

(function () {
  const moveNotificationToBody = () => {
    const notification = document.querySelector("cart-notification");
    if (notification && notification.parentElement !== document.body) {
      document.body.insertBefore(notification, document.body.firstChild);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", moveNotificationToBody);
  } else {
    moveNotificationToBody();
  }

  window.addEventListener("load", moveNotificationToBody);
})();

/* ============================================
   ANIMATION KEYFRAMES
   ============================================ */

if (!document.querySelector("#brutalist-animations")) {
  const style = document.createElement("style");
  style.id = "brutalist-animations";
  style.textContent = `
    .brutalist-button.loading,
    .button.loading {
      position: relative;
      color: transparent;
      pointer-events: none;
    }

    .brutalist-button.loading::after,
    .button.loading::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      left: 50%;
      margin-left: -10px;
      margin-top: -10px;
      border: 2px solid transparent;
      border-top-color: #FFFFFF;
      border-radius: 50%;
      animation: spinner 0.6s linear infinite;
    }

    .brutalist-button--secondary.loading::after {
      border-top-color: #000000;
    }

    @keyframes spinner {
      to {
        transform: rotate(360deg);
      }
    }
  `;
  document.head.appendChild(style);
}

/* ============================================
   BRUTALIST MODAL GALLERY - JAVASCRIPT
   Full-screen lightbox with Swiper sync
   ============================================ */

(function () {
  "use strict";

  let modalSwiper = null;
  let modalThumbsSwiper = null;
  let mainGallerySwiper = null;

  function initModalGallery(sectionId) {
    const modalGallery = document.getElementById("ModalGallery-" + sectionId);
    if (!modalGallery) return;

    const modalSwiperEl = document.getElementById("ModalSwiper-" + sectionId);
    const modalThumbsEl = document.getElementById(
      "ModalThumbsSwiper-" + sectionId
    );
    const mainGalleryEl = document.getElementById("MainGallery-" + sectionId);
    const closeBtn = modalGallery.querySelector(
      ".brutalist-modal-gallery__close"
    );
    const backdrop = modalGallery.querySelector(
      ".brutalist-modal-gallery__backdrop"
    );
    const counterCurrent = modalGallery.querySelector(
      ".brutalist-modal-gallery__counter-current"
    );
    const counterTotal = modalGallery.querySelector(
      ".brutalist-modal-gallery__counter-total"
    );

    // Store reference to main gallery Swiper (already initialized in product-media-gallery)
    if (mainGalleryEl && mainGalleryEl.swiper) {
      mainGallerySwiper = mainGalleryEl.swiper;
    }

    // Initialize modal thumbnails Swiper
    if (modalThumbsEl) {
      modalThumbsSwiper = new Swiper(modalThumbsEl, {
        freeMode: true,
        watchSlidesProgress: true,
        spaceBetween: 8,
        breakpoints: {
          0: {
            slidesPerView: 4,
          },
          750: {
            slidesPerView: 6,
          },
          990: {
            slidesPerView: 8,
          },
        },
      });
    }

    // Initialize modal main Swiper
    if (modalSwiperEl) {
      modalSwiper = new Swiper(modalSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: modalGallery.querySelector(
            ".brutalist-modal-gallery__arrow--next"
          ),
          prevEl: modalGallery.querySelector(
            ".brutalist-modal-gallery__arrow--prev"
          ),
        },
        thumbs: modalThumbsSwiper
          ? {
              swiper: modalThumbsSwiper,
            }
          : undefined,
        keyboard: {
          enabled: true,
        },
        a11y: {
          enabled: true,
        },
        on: {
          slideChange: function () {
            if (counterCurrent) {
              counterCurrent.textContent = this.activeIndex + 1;
            }
          },
        },
      });
    }

    // Open modal function
    function openModal(startIndex = 0) {
      if (!modalSwiper) return;

      // Set initial slide
      modalSwiper.slideTo(startIndex, 0);

      // Show modal
      modalGallery.classList.add("is-open");
      modalGallery.setAttribute("aria-hidden", "false");

      // Lock body scroll
      document.body.classList.add("brutalist-modal-gallery-open");

      // Update counter
      if (counterCurrent) {
        counterCurrent.textContent = startIndex + 1;
      }

      // Focus close button for accessibility
      if (closeBtn) {
        closeBtn.focus();
      }

      // Pause main gallery videos
      pauseMainGalleryMedia();
    }

    // Close modal function
    function closeModal() {
      modalGallery.classList.remove("is-open");
      modalGallery.setAttribute("aria-hidden", "true");
      document.body.classList.remove("brutalist-modal-gallery-open");

      // Pause modal videos when closing
      pauseModalMedia();
    }

    // Pause all media in main gallery
    function pauseMainGalleryMedia() {
      if (!mainGalleryEl) return;
      const videos = mainGalleryEl.querySelectorAll("video");
      videos.forEach((video) => {
        video.pause();
      });
    }

    // Pause all media in modal
    function pauseModalMedia() {
      if (!modalSwiperEl) return;
      const videos = modalSwiperEl.querySelectorAll("video");
      videos.forEach((video) => {
        video.pause();
      });
    }

    // Click handlers for main gallery images
    const mainGallerySlides = mainGalleryEl
      ? mainGalleryEl.querySelectorAll(".brutalist-gallery-slide")
      : [];
    mainGallerySlides.forEach((slide, index) => {
      const img = slide.querySelector(".brutalist-gallery-image");
      if (img) {
        slide.style.cursor = "zoom-in";
        slide.addEventListener("click", function (e) {
          e.preventDefault();
          // Get current main gallery index
          const currentIndex = mainGallerySwiper
            ? mainGallerySwiper.activeIndex
            : index;
          openModal(currentIndex);
        });
      }
    });

    // Close button click
    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    // Backdrop click
    if (backdrop) {
      backdrop.addEventListener("click", closeModal);
    }

    // ESC key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modalGallery.classList.contains("is-open")) {
        closeModal();
      }
    });

    // Prevent clicks inside modal content from closing
    const modalContainer = modalGallery.querySelector(
      ".brutalist-modal-gallery__container"
    );
    if (modalContainer) {
      modalContainer.addEventListener("click", function (e) {
        if (e.target === this) {
          closeModal();
        }
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      // Find all product sections and initialize modal galleries
      const productSections = document.querySelectorAll(
        ".brutalist-product-section"
      );
      productSections.forEach((section) => {
        const sectionId = section.getAttribute("data-section");
        if (sectionId) {
          // Wait for main gallery to be initialized first
          setTimeout(() => initModalGallery(sectionId), 100);
        }
      });
    });
  } else {
    // Already loaded
    const productSections = document.querySelectorAll(
      ".brutalist-product-section"
    );
    productSections.forEach((section) => {
      const sectionId = section.getAttribute("data-section");
      if (sectionId) {
        setTimeout(() => initModalGallery(sectionId), 100);
      }
    });
  }
})();
